<template>
    <v-layout style='flex: 0 0 auto !important;' column>
        <v-card tile flat>
            <v-list subheader expand class='mb-0 pb-0'>
                <v-list-item @click="visibility.create=true" v-if="dataSourceCreateAllowed">
                    <v-list-item-content class='pl-4'>
                        <v-list-item-title>Добавить источник данных</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-icon>add</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-snackbar v-model="snackbar"> Задача на загрузку данных отдана</v-snackbar>
                <v-progress-linear :color='$store.getters.uiAccent' class='mb-0 py-0 mt-0' height='1'
                                   :active='indicator.list' :indeterminate='true'></v-progress-linear>
                <v-divider v-if='!indicator.list'></v-divider>
                <template v-if='!dataSources.length'>
                    <v-list-item link>
                        <v-list-item-content class='pl-4'>
                            <v-list-item-title>Нет источников данных</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                </template>

                <v-list-group
                        no-action
                        v-for='(value, key) in groupedDataSources'
                        :key='key'
                        style='border-bottom: 1px solid;border-color:#EEEEEE;'
                >

                    <template v-slot:activator>

                        <v-list-item style='background: transparent !important;'
                                     :two-line='!$vuetify.breakpoint.smAndUp' class='mx-0 px-0'>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <v-layout row wrap mx-4>
                                        <span class='font-weight-medium'>
                                            {{ value.name }}
                                        </span>
                                    </v-layout>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                    </template>

                    <template v-if="!value.dataSources.length">
                        <v-list-item link>
                            <v-list-item-content class='pl-4'>
                                <v-list-item-title style="color: red">Источники данных не подключены</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>

                    <template v-if="value.dataSources.length">
                        <v-list-item v-for='(s, si) in value.dataSources' link class='pl-4'>

                            <v-list-item-action class='ml-4 mr-5'>
                                <span>{{ si+1 }}</span>
                            </v-list-item-action>

                            <v-list-item-content>
                                <!--  Yandex WordStat  -->
                                <template v-if="value.id === 'wordstat'">
                                    <v-list-item-title>
                                        <p>Название: <b>{{ s.data_source_name }}</b></p>
                                    </v-list-item-title>
                                    <v-list-item-title>
                                        <v-container>
                                            <v-row>
                                                <span>Фразы: </span>
                                                <v-chip
                                                        class="ma-2"
                                                        color="teal"
                                                        text-color="white"
                                                        v-for="phrase in s.data_source_ext.phrases"
                                                        tile
                                                >
                                                    <v-icon left>
                                                        mdi-label
                                                    </v-icon>
                                                    <span>{{ phrase }}</span>
                                                </v-chip>
                                            </v-row>
                                        </v-container>
                                    </v-list-item-title>
                                    <v-list-item-title>
                                        <span>Регионы: </span>
                                        <v-chip
                                                class="ma-2"
                                                color="teal"
                                                text-color="white"
                                                v-for="region in s.data_source_ext.regions"
                                        >
                                            <v-icon left>
                                                mdi-crosshairs-gps
                                            </v-icon>
                                            <span>{{ region.region_name }}</span>
                                        </v-chip>
                                    </v-list-item-title>

                                </template>

                                <!-- Similar Web -->
                                <template v-if="value.id === 'similarweb'">
                                    <v-list-item-title>
                                        <span> {{s.data_source_name}}</span>
                                    </v-list-item-title>
                                </template>


                            </v-list-item-content>


                            <v-list-item-action title="Запустить скачивание" v-if="dataSourceDeleteAllowed">
                                <v-btn class='mr-1' icon @click.stop.prevent='downloadData(s)'
                                       :disabled="downloadButtonDisabled">
                                    <v-icon color='green'>mdi-play</v-icon>
                                </v-btn>
                            </v-list-item-action>

                            <v-list-item-action v-if="dataSourceDeleteAllowed">
                                <v-btn class='mr-1' small icon
                                       @click.stop.prevent='castDataSource(s); visibility.update = true;'>
                                    <v-icon small color='light-blue darken-1'>mdi-square-edit-outline</v-icon>
                                </v-btn>
                            </v-list-item-action>

                            <v-list-item-action v-if="dataSourceDeleteAllowed">
                                <v-btn class='pa-0 ma-0' small icon
                                       @click.stop.prevent='castDataSource(s); visibility.delete = true;'>
                                    <v-icon small :color='$store.getters.uiAccentIcon'>delete_outline</v-icon>
                                </v-btn>
                            </v-list-item-action>


                        </v-list-item>
                    </template>


                </v-list-group>

            </v-list>
        </v-card>
        <data-source-create :initialState.sync='visibility.create' :postAction='getProjectDataSources'
                            :project='project'></data-source-create>
        <data-source-update :initialState.sync='visibility.update' :postAction='getProjectDataSources'
                            :dataSource='cursorDataSource'></data-source-update>
        <data-source-delete :initialState.sync='visibility.delete' :data='cursorDataSource'
                            :postAction='getProjectDataSources' :projectId='project.project_id'></data-source-delete>
    </v-layout>
</template>

<script>

    import projectHandlers from '@/mixins/project';
    import {orderBy} from 'lodash-es'
    import CreateDataSource from '@/components/entities/datasources/CreateDialog.vue';
    import UpdateDataSource from '@/components/entities/datasources/UpdateDialog.vue';
    import DeleteDataSource from '@/components/entities/datasources/DeleteDialog.vue';

    export default {
        name: 'ProjectDataSources',
        props: ['data'],
        mixins: [projectHandlers],
        components: {
            'data-source-create': CreateDataSource,
            'data-source-update': UpdateDataSource,
            'data-source-delete': DeleteDataSource,
        },
        data() {
            return {
                visibility: {
                    update: false,
                    create: false,
                    delete: false,
                    info: false,
                    state: false,
                    factors: false
                },
                snackbar: false,
                project: this.data,
                indicator: {
                    list: false,
                    sync: false,
                    updates: false
                },
                downloadButtonDisabled: false,
                dataSources: [],
                cursorDataSource: {
                    // data_source_type_id: null,
                    // data_source_name: "",
                    provider_name: "",
                    data_source_ext: {},
                    data_source_int: {
                        phrases: [],
                        regions: [],
                        parent: "",
                        website: ""
                    },
                    meta: {},
                    // project_id: this.data.project_id,
                    // vertical_id: this.data.vertical_id
                },
                valid: false,
                showNonActive: false,
            }
        },
        computed: {
            dataSourceCreateAllowed() {
                return ['X', 'U'].includes(this.project.mode_statplaces)
            },
            dataSourceDeleteAllowed() {
                return ['X', 'U'].includes(this.project.mode_statplaces)
            },
            groupedDataSources() {
                const groups = JSON.parse(JSON.stringify(this.$store.state.dataSourceTypes || []));
                const s = this.dataSources;
                for (let i in orderBy(groups, 'name')) {
                    let dataSources = []
                    if (this.showNonActive) {
                        dataSources = s.filter(f => f.data_source_type_id === groups[i].id);
                    } else {
                        dataSources = s.filter(f => f.active && f.data_source_type_id === groups[i].id);
                    }
                    dataSources = orderBy(dataSources, "data_source_name")
                    groups[i] = {
                        ...groups[i],
                        'dataSources': dataSources
                    }
                }
                return groups
            }
        },
        watch: {
            data(value) {
                if (value) {
                    this.project = value;
                    this.getProjectDataSources();
                }
            }
        },
        methods: {
            getProjectDataSources() {
                this.indicator.list = true;
                this.$store.dispatch('fillDataSourceTypes').then(
                    r => {
                        this.getProjectPropertyPromise('datasources').then((r) => {
                            let response = r.body
                            this.indicator.list = false
                            if (response.result) {
                                this.dataSources = response.data;
                            } else {
                                console.log('error fetch project statplaces', response.data)
                            }
                        });
                    },
                    error => {
                        console.log(error)
                    }

                )

            },
            provider(data_source_type_id) {
                const provider = (this.$store.state.dataSourceTypes || []).filter(s => s.id === data_source_type_id);
                return provider[0] || {name: '_blank'}
            },
            castDataSource(s) {
                if (s) {
                    this.cursorDataSource = {
                        ...s,
                        data_source_int: {
                            parent: s.data_source_int.parent,
                            phrases: s.data_source_int.phrases.map(el => {
                                return {text: el}
                            }),
                            regions: s.data_source_int.regions.map(el => {
                                return el.region_id
                            }),
                            website: s.data_source_int.website
                        },
                        provider_name: this.provider(s.data_source_type_id).name
                    }
                }
            },
            downloadData(s) {
                this.downloadButtonDisabled = true;
                const params = {
                    id: s.id
                };
                const routes = {
                    wordstat: '/db/fetch_wordstat',
                    similarweb: '/db/fetch_similarweb'
                };
                this.$http.post(this.$store.getters.endpoint + routes[s.data_source_type_id], params, {
                    headers: {...this.$store.state.restrictedHeaders, ...{'Content-Type': 'application/json;charset=UTF-8'}}
                }).then(r => {
                    let response = r.body;
                    this.snackbar = true;
                }).catch(e => {
                    console.log(e)
                }).finally(() => {
                    setTimeout(() => {
                        this.snackbar = false;
                        this.downloadButtonDisabled = false;
                        this.getProjectDataSources();
                    }, 5000);
                })
            }
        },
        mounted() {
            this.getProjectDataSources();
        }

    }
</script>
